/*
  EWA makale şablonu: bağlantı kopyalama + süreç sütunu + soru çubuğu.

  Tek kaynak yazının içindeki kısa cevaplar listesi (nav.ewa-answers > a[href="#h2-id"]).
  Buradan kurulur:
    - süreç sütunu (≥1100px, .ewa-rail): soru + cevap + soru başına ilerleme çizgisi
    - soru çubuğu (<1100px, .ewa-qbar): "2/6 · soru" + bölümlü ilerleme, liste ekrandan çıkınca iner
  Okuma çizgisi header'ın altından ekranın %30'u kadar aşağıda; bir soru, başlığı bu çizgiyi
  geçince "okunuyor" sayılır, bir sonraki başlığa kadar ilerler.
*/
(() => {
  const root = document.querySelector('[data-ewa-article]');
  if (!root) return;

  /* Paylaş: bağlantıyı kopyala (ikon 2 sn onaya döner, durum ekran okuyucuya) + cihazın paylaş
     menüsü varsa ayrı buton (PDP'deki davranışın aynısı: menü yoksa kopyala). */
  const status = root.querySelector('[data-ewa-share-status]');
  const copyBtn = root.querySelector('[data-ewa-copy]');
  const copyLink = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      if (status) status.textContent = status.dataset.copiedLabel || '';
      if (copyBtn) {
        copyBtn.classList.add('is-done');
        window.clearTimeout(copyLink.t);
        copyLink.t = window.setTimeout(() => {
          copyBtn.classList.remove('is-done');
          if (status) status.textContent = '';
        }, 2000);
      }
    } catch (e) {
      if (status) status.textContent = url;
    }
  };
  if (copyBtn) copyBtn.addEventListener('click', () => copyLink(copyBtn.dataset.ewaCopy));
  const shareBtn = root.querySelector('[data-ewa-share]');
  if (shareBtn && navigator.share) {
    shareBtn.hidden = false;
    shareBtn.addEventListener('click', async () => {
      try {
        await navigator.share({ title: shareBtn.dataset.shareTitle, url: shareBtn.dataset.shareUrl });
      } catch (e) {
        if (!e || e.name !== 'AbortError') copyLink(shareBtn.dataset.shareUrl);
      }
    });
  }

  const body = root.querySelector('[data-ewa-body]');
  const answers = body && body.querySelector('.ewa-answers');
  if (!answers) return;
  if (body.dataset.answersId) answers.id = body.dataset.answersId;

  const items = [...answers.querySelectorAll('a[href^="#"]')]
    .map((a) => {
      const id = decodeURIComponent(a.getAttribute('href').slice(1));
      const heading = document.getElementById(id);
      if (!heading) return null;
      const q = a.querySelector('.ewa-answers__q');
      const ans = a.querySelector('.ewa-answers__a');
      return {
        id,
        heading,
        source: a,
        q: (q ? q.textContent : heading.textContent).trim(),
        a: ans ? ans.textContent.trim() : '',
        short: (heading.dataset.short || '').trim(),
      };
    })
    .filter(Boolean);
  if (items.length < 2) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const wide = window.matchMedia('(min-width: 1100px)');

  const rail = root.querySelector('[data-ewa-rail]');
  const railList = root.querySelector('[data-ewa-rlist]');
  const qbar = root.querySelector('[data-ewa-qbar]');
  const qcount = root.querySelector('[data-ewa-qcount]');
  const qlabel = root.querySelector('[data-ewa-qlabel]');
  const qsegs = root.querySelector('[data-ewa-qsegs]');

  items.forEach((it) => {
    const li = document.createElement('li');
    li.className = 'ewa-rail__item';
    const link = document.createElement('a');
    link.className = 'ewa-rail__link';
    link.href = `#${it.id}`;
    link.innerHTML =
      '<span class="ewa-rail__dot" aria-hidden="true"></span><span class="ewa-rail__q"></span><span class="ewa-rail__a"></span>';
    /* Hover: sitenin kayan alt çizgisi (base-brand .aycan-slide-underline, a:hover tetikler). */
    const qText = document.createElement('span');
    qText.className = 'aycan-slide-underline';
    qText.textContent = it.q;
    link.querySelector('.ewa-rail__q').appendChild(qText);
    link.querySelector('.ewa-rail__a').textContent = it.a;
    const fill = document.createElement('span');
    fill.className = 'ewa-rail__fill';
    fill.setAttribute('aria-hidden', 'true');
    li.append(link, fill);
    railList.appendChild(li);
    it.row = li;
    it.link = link;

    const seg = document.createElement('span');
    seg.className = 'ewa-qbar__seg';
    seg.appendChild(document.createElement('i'));
    qsegs.appendChild(seg);
    it.seg = seg;
  });
  /* Sütun yazıdan türüyor; yönü de yazının (gövde dir="auto") yönü olsun. /ar'de İngilizce yazı
     sağa yaslı ve noktalaması ters basılmasın: nokta, çizgi ve metin aynı taraftan başlar. */
  const contentDir = getComputedStyle(body).direction;
  rail.setAttribute('dir', contentDir);
  qbar.setAttribute('dir', contentDir);
  rail.hidden = false;
  qbar.hidden = false;
  root.querySelector('.ewa-layout').classList.add('has-rail');

  /* Bağlantıyla atlama: hareket azaltılmışsa anında; odak başlığa (ekran okuyucu oradan devam eder). */
  const jumpTo = (target, hash) => {
    target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', hash);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };
  const onJump = (event) => {
    const link = event.currentTarget;
    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    jumpTo(target, link.hash);
  };
  items.forEach((it) => {
    it.source.addEventListener('click', onJump);
    it.link.addEventListener('click', onJump);
  });
  const qlink = root.querySelector('[data-ewa-qbar-link]');
  if (qlink) qlink.addEventListener('click', onJump);

  const headerBottom = () =>
    parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

  let active = -2;
  let queued = false;
  const update = () => {
    queued = false;
    const top = headerBottom();
    const line = top + window.innerHeight * 0.3;
    const end = body.getBoundingClientRect().bottom;
    const starts = items.map((it) => it.heading.getBoundingClientRect().top);

    let current = -1;
    items.forEach((it, i) => {
      const start = starts[i];
      const next = i + 1 < items.length ? starts[i + 1] : end;
      it.p = Math.min(1, Math.max(0, (line - start) / Math.max(1, next - start)));
      if (line >= start) current = i;
    });

    items.forEach((it, i) => {
      const p = it.p.toFixed(3);
      it.row.style.setProperty('--p', p);
      it.seg.style.setProperty('--p', p);
      it.row.classList.toggle('is-active', i === current);
      it.row.classList.toggle('is-done', i < current);
      if (i === current) it.link.setAttribute('aria-current', 'true');
      else it.link.removeAttribute('aria-current');
    });

    if (current !== active) {
      active = current;
      qcount.textContent = current >= 0 ? `${current + 1}/${items.length}` : '';
      qlabel.textContent = current >= 0 ? items[current].short || items[current].q : '';
    }

    const listGone = answers.getBoundingClientRect().bottom < top;
    qbar.classList.toggle('is-on', !wide.matches && listGone && end > top + qbar.offsetHeight);
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  update();
})();
